import { Component, OnInit, Input, TemplateRef} from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { LocationSearch} from 'src/app//models/locations';
import { emptyFields} from 'src/app/utilities/common-file';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { Messages } from 'src/app/utilities/message';
import { CommonService } from 'src/app/utilities/common-service';
 import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ProductService } from '../../product.service';

@Component({
  selector: 'app-assign-location',
  templateUrl: './assign-location.component.html',
})
export class AssignLocationComponent implements OnInit {

  @Input() product: any; // for data get from the drawer component
   data:any;
  loading = false;
  emptyField = emptyFields;
  confirmText:any;
  productModal: NzModalRef;
  commentForm: UntypedFormGroup;
  shwoLocationName: any;
  private tableData: NzTableData<LocationSearch, any> = new NzTableData<LocationSearch, any>(new LocationSearch(), 'fullName');
  constructor(
    private fb: UntypedFormBuilder, 
    private productService: ProductService,
    private modal: NzModalService, 
    private notification: NzNotificationService,
    private commonService: CommonService, 
    private drawerRef: NzDrawerRef<string>) { 
      // this.commentForm = this.fb.group({
      //   comments: ['']
      // });
      this.commentForm = this.fb.group({
        comments: [''],
        isAvailable: [],
      });
    }

  ngOnInit() {
    this.data=this.product;
    this.refresh();
  }
 // For List
 refresh(startFromPageOne: boolean = true): void {
  this.loading = true;
  this.tableData.data = [];
  if (startFromPageOne) {
    this.tableData.pageIndex = 1;
  }
   this.tableData.search.merchant = this.product.merchantId;
  this.tableData.search.productId = this.product.id;
   this.productService.getLocationsNonLinkedProductWithLimit(this.tableData).subscribe((response: any) => {
    this.loading = false;
    this.tableData.total = response.data.total;
    this.tableData.data = response.data.locations;

}, err => {
  this.loading = false;
  this.tableData.data = [];
  this.tableData.total = 0;
});
}
// For Page Index change
onIndexChange(event) {
  this.tableData.pageIndex = event;
  this.refresh(false);
}
 // To Show Status
 getStatus(status) {
  return this.commonService.getStatus(status);
}
 // For User Status Tag color
 getStatusColor(status) {
  return this.commonService.getStatusColor(status);
}
 // To Close drawer
 close(): void {
  this.drawerRef.close();
}
 //Get appCode 
 getMerchantAppCode(code){
   return  this.commonService.getCurrencySymbol(code);
 }
 // Merchant Product Assign Location popup confirmation
 merchantProductAssignLocationConfirm(
  row,
  merchantProductAssignLocationModal: TemplateRef<{}>
) {
  this.shwoLocationName = row;
   this.confirmText="Are you sure you want to Assign Product to Location";
   this.commentForm.reset();
   this.commentForm.controls.isAvailable.setValue(false);
  this.productModal = this.modal.create({
    nzContent: merchantProductAssignLocationModal,
    nzClosable: false,
    nzMaskClosable: false,
    nzOkText: 'Yes',
    nzOnOk: () => this.assignLocation(row),
    nzCancelText: 'No',
    nzOnCancel: () => console.log('Cancel')
  });
}

destroyModal() {
  this.productModal.destroy();
}
  // Assign Location API
  assignLocation(data) {
    const args = {
      merchantId: data.merchantId,
      productId: this.product.id,
      appCode: this.data.appCode,
      isAvailable: this.commentForm.value.isAvailable,
      locationId: data.id,
      comments: this.commentForm.value.comments,
    }
     this.productService.merchantProductAssignLocation(args).subscribe(
      (res) => {
        this.refresh();
        this.notification.success(Messages.saved, '', {
          nzKey: 'key',
        });
      },
      (error) => {
      });
  }
  // Merchant Product Assign Location popup confirmation
 editassignLocation(
  row,
  merchantProductAssignLocationModal: TemplateRef<{}>
) {
  this.commentForm.patchValue(row);
  this.confirmText ='Are you sure you want to update';
  this.productModal = this.modal.create({
    nzContent: merchantProductAssignLocationModal,
    nzClosable: false,
    nzMaskClosable: false,
    nzOkText: 'Yes',
    nzOnOk: () => this.updateAssignLocation(row),
    nzCancelText: 'No',
    nzOnCancel: () => console.log('Cancel')
  });
}
  // Update Assign Location API
  updateAssignLocation(data) {
    const args = {
      merchantId: data.merchantId,
      productId: this.product.id,
      appCode: this.tableData.search.appCode,
      locationId: data.id,
      isAvailable: this.commentForm.value.isAvailable,
      comments: this.commentForm.value.comments,
    }
    this.productService.editMerchantProductLocation(data.mlpId, args).subscribe(
      (res) => {
        this.refresh();
        this.notification.success(Messages.updated, '', {
          nzKey: 'key'
        });
      },
      (error) => {
      });
  }
   // Delete confirmation popup
   assignLocationDelete(item) {
    this.modal.confirm({
      nzTitle: 'Are you sure you want remove Merchant Product ' + this.data.name + ' from Location ' + item.name + ' ?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.deleteProductLocation(item),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  // Delete API
  deleteProductLocation(item) {
    this.productService.deleteMerchantProductLocation(item.mlpId).subscribe((response: any) => {
      this.notification.success(response.message, '', {
        nzKey: 'key'
      });
      this.refresh();
    }, err => {

    });
  }
  getAvailableColor(value) {
    return this.commonService.getAvailableColor(value);
   }
   getAssignedColor(value){
    return this.commonService.getAssignedColor(value);
   }
}
